import { REDIRECT_PAY_PLUS, REFRESH } from "../types/website.types";
import { deepClone } from "../../utils/utils";

const initialState = {
  redirectPayPlus: false,
  refreshApp: false,
};

const reducer = function requestReducer(state = initialState, action) {
  const newState = deepClone(state);
  switch (action.type) {
    case REFRESH:
      newState.refreshApp = true;
      return newState;
    case REDIRECT_PAY_PLUS:
      const { redirect } = action;
      newState.redirectPayPlus = redirect;
      return newState;
    default:
      return newState;
  }
};

export default reducer;
